// extracted by mini-css-extract-plugin
export default {"appleButton":"AppleLoginButton_appleButton__Yx4ny","appleIcon":"AppleLoginButton_appleIcon__l1XkE"};